export interface ICommand { }

export class DeleteShareCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.DataSharing.Shares.Commands.DeleteShareCommandV1, TCh.Domain.DataSharing'

	Id: string
	DeletedBy: string

	constructor (id: string, deletedBy: string)
	{
		this.Id = id
		this.DeletedBy = deletedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.DataSharing.Shares.Commands.DeleteShareCommandV1, TCh.Domain.DataSharing'
	}

}

export class PauseSharingCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.DataSharing.Shares.Commands.PauseSharingCommandV1, TCh.Domain.DataSharing'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.DataSharing.Shares.Commands.PauseSharingCommandV1, TCh.Domain.DataSharing'
	}

}

export class ResumeSharingCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.DataSharing.Shares.Commands.ResumeSharingCommandV1, TCh.Domain.DataSharing'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.DataSharing.Shares.Commands.ResumeSharingCommandV1, TCh.Domain.DataSharing'
	}

}

export class SendEmailConfirmationCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.DataSharing.Shares.Commands.SendEmailConfirmationCommandV1, TCh.Domain.DataSharing'

	Id: string
	Email: string

	constructor (id: string, email: string)
	{
		this.Id = id
		this.Email = email
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.DataSharing.Shares.Commands.SendEmailConfirmationCommandV1, TCh.Domain.DataSharing'
	}

}

export class SendNotificationCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.DataSharing.Shares.Commands.SendNotificationCommandV1, TCh.Domain.DataSharing'

	Id: string
	Message: string
	Emails: any

	constructor (id: string, message: string, emails: any)
	{
		this.Id = id
		this.Message = message
		this.Emails = emails
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.DataSharing.Shares.Commands.SendNotificationCommandV1, TCh.Domain.DataSharing'
	}

}

export class ShareDataCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.DataSharing.Shares.Commands.ShareDataCommandV1, TCh.Domain.DataSharing'

	Id: string
	OrganizationUnitId: string
	WorkspaceId: string
	SharedBy: string
	SharedAt: any | null
	SharedFor: any | null
	SharedWith: any
	ResourceProviderName: string
	ResourceId: string
	EmailsProviderName: string
	EmailsProviderConfig: string
	EmailsProviderGroups: any

	constructor (id: string, organizationUnitId: string, workspaceId: string, sharedBy: string, sharedAt: any | null, sharedFor: any | null, sharedWith: any, resourceProviderName: string, resourceId: string, emailsProviderName: string, emailsProviderConfig: string, emailsProviderGroups: any)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.WorkspaceId = workspaceId
		this.SharedBy = sharedBy
		this.SharedAt = sharedAt
		this.SharedFor = sharedFor
		this.SharedWith = sharedWith
		this.ResourceProviderName = resourceProviderName
		this.ResourceId = resourceId
		this.EmailsProviderName = emailsProviderName
		this.EmailsProviderConfig = emailsProviderConfig
		this.EmailsProviderGroups = emailsProviderGroups
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.DataSharing.Shares.Commands.ShareDataCommandV1, TCh.Domain.DataSharing'
	}

}

export class UpdateSharedWithCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.DataSharing.Shares.Commands.UpdateSharedWithCommandV1, TCh.Domain.DataSharing'

	Id: string
	SharedWith: any

	constructor (id: string, sharedWith: any)
	{
		this.Id = id
		this.SharedWith = sharedWith
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.DataSharing.Shares.Commands.UpdateSharedWithCommandV1, TCh.Domain.DataSharing'
	}

}

